export const enum ActionStatus {
  PENDING_SELLER_ACTION = 'PENDING_SELLER_ACTION',
  PENDING_BUYER_ACTION = 'PENDING_BUYER_ACTION',
  NO_ACTION = 'NO_ACTION',
  HOLD = 'HOLD',
  REMOVED = 'REMOVED',
  EXPIRED = 'EXPIRED'
}

export enum UpdateVehiclesActions {
  DEFAULT = 'default',
  DISCLOSURES_YELLOW_LIGHTS = 'DISCLOSURES_YELLOW_LIGHTS',
  VEHICLE_STATUS_CHANGE = 'VEHICLE_STATUS_CHANGE',
  MARK_ARRIVED = 'MARK_ARRIVED',
  RELEASE_PROCEEDS = 'RELEASE_PROCEEDS',
  REVERSE_RELEASE_PROCEEDS = 'REVERSE_RELEASE_PROCEEDS'
}

export enum AdminModalDisplay {
  FORM_TEMPLATE = 'formTemplate',
  RESULTS_TEMPLATE = 'resultsTemplate',
  ERROR_TEMPLATE = 'errorTemplate'
}

export enum VehicleStatusAction {
  ACTIVE = 'ACTIVE',
  HOLD = 'HOLD',
  REMOVE = 'REMOVED'
}

export enum GroundingAction {
  GROUND = 'GROUND',
  UNGROUND = 'UNGROUND'
}
